import { appSetLoading, appSetSendingRequest } from "../store/actions/appAction";
import axios from "../axios/axios";
import { errorDispatcher } from "../helpers";
import { setTableData } from "../store/actions/dataTableAction";
import { apiSetAlert } from "./appApi";
import Messages from "../lang/fa/messages";

export const apiAdminDailyReport = (token, callback, date, businessId) => (dispatch, getState) => {
  let url = businessId ? `admin/business/${businessId}` : "admin/daily/reports";
  if (date) {
    url += `?selectedDate=${date}`;
  }

  dispatch(appSetSendingRequest(true));
  axios
    .get(url, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiAdminUsersReport =
  ({ pagination, token, type, sort, search }) =>
  (dispatch, getState) => {
    let url = `admin/users?limit=${pagination.limit ?? 10}&page=${pagination.page ?? 1}`;
    // if (date) {
    //     url += `?selectedDate=${date}`;
    // }

    let params = {};

    if (sort) {
      params.key = sort.key;
      params.dir = sort.dir;
    }

    if (search) {
      params.mainColumn = search.mainColumn;
      params.searchText = search.searchText;
      params.subColumn = search.subColumn;
      params.altSearchText = search.altSearchText;
      params.type = search.type;
    }

    dispatch(appSetLoading());
    axios
      .get(url, {
        headers: { Authorization: `Bearer ${token}` },
        params,
      })
      .then((response) => {
        dispatch(setTableData(response.data.users, response.data.paginate));
        dispatch(appSetLoading(false));
      })
      .catch((error) => {
        errorDispatcher(error, dispatch);
      });
  };

export const apiAdminDemoReport =
  ({ pagination, token, type, sort, search }) =>
  (dispatch, getState) => {
    let url = `admin/demo?limit=${pagination.limit ?? 10}&page=${pagination.page ?? 1}`;

    let params = {};

    if (sort) {
      params.key = sort.key;
      params.dir = sort.dir;
    }

    if (search) {
      params.mainColumn = search.mainColumn;
      params.searchText = search.searchText;
      params.subColumn = search.subColumn;
      params.altSearchText = search.altSearchText;
      params.type = search.type;
    }

    dispatch(appSetLoading());
    axios
      .get(url, {
        headers: { Authorization: `Bearer ${token}` },
        params,
      })
      .then((response) => {
        dispatch(setTableData(response.data.demoUsers, response.data.paginate));
        dispatch(appSetLoading(false));
      })
      .catch((error) => {
        errorDispatcher(error, dispatch);
      });
  };

export const apiAdminActiveSubscriptionsReport =
  ({ pagination, token, type, sort, search }) =>
  (dispatch, getState) => {
    let url = `admin/businesses/active?limit=${pagination.limit ?? 10}&page=${pagination.page ?? 1}`;

    let params = {};

    if (sort) {
      params.key = sort.key;
      params.dir = sort.dir;
    }

    if (search) {
      params.mainColumn = search.mainColumn;
      params.searchText = search.searchText;
      params.subColumn = search.subColumn;
      params.altSearchText = search.altSearchText;
      params.type = search.type;
    }

    dispatch(appSetLoading());
    axios
      .get(url, {
        headers: { Authorization: `Bearer ${token}` },
        params,
      })
      .then((response) => {
        dispatch(setTableData(response.data.businesses, response.data.paginate));
        dispatch(appSetLoading(false));
      })
      .catch((error) => {
        errorDispatcher(error, dispatch);
      });
  };

export const apiAdminExpiringSubscriptionsReport =
  ({ pagination, token, type, sort, search }) =>
  (dispatch, getState) => {
    let url = `admin/businesses/expiring?limit=${pagination.limit ?? 10}&page=${pagination.page ?? 1}`;

    let params = {};

    if (sort) {
      params.key = sort.key;
      params.dir = sort.dir;
    }

    if (search) {
      params.mainColumn = search.mainColumn;
      params.searchText = search.searchText;
      params.subColumn = search.subColumn;
      params.altSearchText = search.altSearchText;
      params.type = search.type;
    }

    dispatch(appSetLoading());
    axios
      .get(url, {
        headers: { Authorization: `Bearer ${token}` },
        params,
      })
      .then((response) => {
        dispatch(setTableData(response.data.businesses, response.data.paginate));
        dispatch(appSetLoading(false));
      })
      .catch((error) => {
        errorDispatcher(error, dispatch);
      });
  };

export const apiAdminUserActivityReport =
  ({ pagination, token, type, sort, search }) =>
  (dispatch, getState) => {
    let url = `admin/businesses/activities?subscription=0&limit=${pagination.limit ?? 10}&page=${
      pagination.page ?? 1
    }`;

    let params = {};

    if (sort) {
      params.key = sort.key;
      params.dir = sort.dir;
    }

    if (search) {
      params.mainColumn = search.mainColumn;
      params.searchText = search.searchText;
      params.subColumn = search.subColumn;
      params.altSearchText = search.altSearchText;
      params.type = search.type;
    }

    dispatch(appSetLoading());
    axios
      .get(url, {
        headers: { Authorization: `Bearer ${token}` },
        params,
      })
      .then((response) => {
        dispatch(setTableData(response.data.businesses, response.data.paginate));
        dispatch(appSetLoading(false));
      })
      .catch((error) => {
        errorDispatcher(error, dispatch);
      });
  };

export const apiAdminClientActivityReport =
  ({ pagination, token, type, sort, search }) =>
  (dispatch, getState) => {
    let url = `admin/businesses/activities?subscription=1&limit=${pagination.limit ?? 10}&page=${
      pagination.page ?? 1
    }`;

    let params = {};

    if (sort) {
      params.key = sort.key;
      params.dir = sort.dir;
    }

    if (search) {
      params.mainColumn = search.mainColumn;
      params.searchText = search.searchText;
      params.subColumn = search.subColumn;
      params.altSearchText = search.altSearchText;
      params.type = search.type;
    }

    dispatch(appSetLoading());
    axios
      .get(url, {
        headers: { Authorization: `Bearer ${token}` },
        params,
      })
      .then((response) => {
        dispatch(setTableData(response.data.businesses, response.data.paginate));
        dispatch(appSetLoading(false));
      })
      .catch((error) => {
        errorDispatcher(error, dispatch);
      });
  };

export const apiAdminUpdateUserCall = (userId, token, callback) => (dispatch, getState) => {
  let url = `admin/user/log?userId=${userId}&callLog=به روزرسانی تماس`;

  dispatch(appSetLoading());
  axios
    .get(url, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(appSetLoading(false));
      dispatch(apiSetAlert("به روزرسانی تماس با موفقیت انجام شد", "success", true));
      callback();
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiAdminUpdateDemoCall = (userId, token, callback) => (dispatch, getState) => {
  let url = `admin/demo/log?demoUserId=${userId}&callLog=به روزرسانی تماس`;

  dispatch(appSetLoading());
  axios
    .get(url, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(appSetLoading(false));
      dispatch(apiSetAlert("به روزرسانی تماس با موفقیت انجام شد", "success", true));
      callback();
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiAdminExtendRate = (token) => (dispatch, getState) => {
  dispatch(appSetLoading());
  axios
    .get("admin/businesses/extendRatio", {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(appSetLoading(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiAdminUpdateSalesExpert =
  ({ token, id, salesExpert }) =>
  (dispatch, getState) => {
    dispatch(appSetLoading());
    axios
      .put(
        "users/change/salesExpert",
        {
          user_id: id,
          salesExpert,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => {
        dispatch(apiSetAlert(Messages.verifyCodeSent, "success"));
        dispatch(appSetSendingRequest(false));
      })
      .catch((error) => {
        errorDispatcher(error, dispatch);
      });
  };
